module.exports = __webpack_public_path__ + "img/cc-mbs-reta-white.059a1f60.png";